module.exports = __webpack_public_path__ + "img/jinjia.ed219a1.png";